import { RouteSpinner } from "@/components/auth/PrivateRoute";
import { useAuth } from "@/contexts/AuthContext";
import { returnTo } from "@/lib/return-to";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

/** Keeps a signed-in user off /login and /signup — and sends them where they were headed. */
export function PublicRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  if (isLoading) return <RouteSpinner />;
  if (isAuthenticated) return <Navigate to={returnTo(location.state, location.search)} replace />;
  return <>{children}</>;
}
